import React, { memo } from 'react'
import {
  RainbowKitProvider,
  cssStringFromTheme,
  lightTheme
} from '@rainbow-me/rainbowkit'
import { WagmiProvider } from 'wagmi'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { useTheme } from '@mui/material'

import { getChain, wagmiConfig } from '../../util/wallet/wagmiConfig'

const queryClient = new QueryClient()

const WalletConnectWrapper = ({ children }) => {
  const theme = useTheme()
  const customTheme = lightTheme({
    accentColor: theme.palette.primary.main,
    fontStack: 'system'
  })
  return (
    <WagmiProvider config={wagmiConfig()}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={null} initialChain={getChain()}>
          <style
            dangerouslySetInnerHTML={{
              __html: `
            :root {
              ${cssStringFromTheme(customTheme)}
            }
          `
            }}
          />
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}

export default memo(WalletConnectWrapper)
